import AutoComplete from "src/decidim/autocomplete";
const autoConfigure = (el) => {
  const config = JSON.parse(el.dataset.autocomplete);
  const textInput = document.createElement("input");
  textInput.type = "text";
  textInput.className = "autocomplete-input";
  el.appendChild(textInput);
  let mode = config.mode || "sticky";
  let selected = null;
  if (config.selected) {
    switch (mode) {
      case "multi":
        selected = config.selected.map((item) => ({
          key: "label",
          value: {
            value: item.value,
            label: item.label
          }
        }));
        break;
      case "sticky":
        selected = { key: "label", value: config.options[config.options.length - 1] };
        break;
      default:
        selected = config.selected;
    }
  }
  const graphqlEscapedQuery = (query) => query.replace(/\\/g, "\\\\").replace(/"/g, '\\"');
  const dataSource = (query, callback) => {
    const apiPath = window.Decidim.config.get("api_path");
    fetch(apiPath, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        query: `{users(filter:{wildcard:"${graphqlEscapedQuery(query)}"}){id,nickname,name,__typename}}`
      })
    }).then((response) => response.json()).then((data) => {
      var _a;
      const users = ((_a = data == null ? void 0 : data.data) == null ? void 0 : _a.users) || [];
      callback(users.map((user) => ({
        value: user.id,
        label: `${user.name} (${user.nickname})`
      })));
    }).catch(() => {
      callback([]);
    });
  };
  const ac = new AutoComplete(textInput, {
    name: config.name,
    placeholder: config.placeholder,
    selected,
    mode,
    searchPrompt: true,
    searchPromptText: config.searchPromptText,
    threshold: 3,
    dataMatchKeys: ["label"],
    dataSource
  });
  return ac;
};
$(() => {
  const $autocompleteDiv = $("[data-autocomplete]");
  if ($autocompleteDiv.length < 1) {
    return;
  }
  $autocompleteDiv.each((_index, element) => {
    autoConfigure(element);
  });
});
